import React from 'react';

const pillars = [
  {
    id: 'finance',
    label: 'Finance',
    description: 'Net worth, retirement, investments & the wheel',
    color: '#2C7A4B',
    bg: '#EEF7F2',
    border: '#2C7A4B33',
  },
  {
    id: 'health',
    label: 'Health',
    description: 'Weight, labs, steps & progress',
    color: '#C17A5A',
    bg: '#FBF3EF',
    border: '#C17A5A33',
  },
  {
    id: 'habits',
    label: 'Habits',
    description: 'Reading, deep work & phone-free dinners',
    color: '#B8922A',
    bg: '#FBF6EA',
    border: '#B8922A33',
  },
  {
    id: 'connect',
    label: 'Connect',
    description: 'Jenny, Miles, Ellie & friendships',
    color: '#3A6FA8',
    bg: '#EDF2F8',
    border: '#3A6FA833',
  },
];

export default function Home({ data, onSelectPillar, user }) {
  const today = new Date();
  const hour = today.getHours();
  const greeting = hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';
  const firstName = user?.name?.split(' ')[0] || 'Josh';

  return (
    <div>
      <div style={{ background: 'white', margin: '0 -24px', padding: '20px 24px 18px', borderBottom: '1px solid #EBEBEB', marginBottom: 20 }}>
        <p style={{ fontSize: 11, color: '#aaa', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 4, fontWeight: 700 }}>
          {today.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}
        </p>
        <h1 style={{ fontFamily: 'DM Serif Display, serif', fontSize: 28, color: '#172A3A', lineHeight: 1.15, margin: 0 }}>
          {greeting}, {firstName}.
        </h1>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 12,
        marginBottom: 48,
      }}>
        {pillars.map((pillar) => (
          <button
            key={pillar.id}
            onClick={() => onSelectPillar(pillar.id)}
            style={{
              background: pillar.bg,
              border: `1.5px solid ${pillar.border}`,
              borderRadius: 16,
              padding: '20px 18px',
              textAlign: 'left',
              cursor: 'pointer',
              transition: 'transform 0.15s ease, box-shadow 0.15s ease',
              display: 'flex',
              flexDirection: 'column',
              minHeight: 140,
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = `0 8px 24px ${pillar.border}`;
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <div style={{ fontSize: 20, fontWeight: 800, color: pillar.color, fontFamily: 'Outfit, sans-serif', marginBottom: 10 }}>
              {pillar.label}
            </div>
            <div style={{ fontSize: 13, color: '#888', lineHeight: 1.5, flex: 1 }}>
              {pillar.description}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
